import React, { useEffect, useState } from 'react';
import Slider from 'react-slick';
import styled from 'styled-components';
import { Box } from '@goodrx/matisse-react';
import { ComponentRenderer } from '@goodrx/x-core';
import { SLICK_CSS } from './constants/slick';
import { DESKTOP_BREAKPOINTS, useBreakpoint } from '../../../../utils/react/useBreakpoint';
const StyledCarousel = styled(Box)`
  ${({
  theme
}) => `        
    margin-left: -${theme.xSpace[4]};
    width: calc(100% + ${theme.xSpace[8]});
  `};
  ${SLICK_CSS}
`;
const StyledComponentRenderer = styled(ComponentRenderer)`
  & {
    ${({
  index,
  theme
}) => index === 0 ? `padding-left: ${theme.xSpace[4]};` : `padding-left: ${theme.xSpace[4]};`}
    ${({
  index,
  items,
  theme
}) => index < items.length - 1 ? 'padding-right: 0px;' : `padding-right: ${theme.xSpace[4]};`}
  }
`;
export const Carousel = ({
  componentMap,
  className,
  tabletContentCollection,
  mobileContentCollection
}) => {
  const [showMobileItems, setShowMobileItems] = useState(false);
  const breakpoint = useBreakpoint();
  useEffect(() => {
    setShowMobileItems(!DESKTOP_BREAKPOINTS.includes(breakpoint));
  }, [breakpoint]);
  const items = !showMobileItems || !(mobileContentCollection !== null && mobileContentCollection !== void 0 && mobileContentCollection.items.length) ? (tabletContentCollection === null || tabletContentCollection === void 0 ? void 0 : tabletContentCollection.items.filter(item => !!item)) || [] : mobileContentCollection === null || mobileContentCollection === void 0 ? void 0 : mobileContentCollection.items.filter(item => !!item);
  const settings = {
    arrows: false,
    dots: false,
    infinite: false,
    speed: 500,
    slidesToShow: items.length,
    slidesToScroll: items.length,
    responsive: [{
      breakpoint: 900,
      settings: {
        slidesToShow: 1.2,
        slidesToScroll: 1,
        infinite: false,
        dots: false
      }
    }]
  };
  return /*#__PURE__*/React.createElement(StyledCarousel, {
    className: className
  }, /*#__PURE__*/React.createElement(Slider, settings, items.map((data, i) => /*#__PURE__*/React.createElement(StyledComponentRenderer, {
    data: data,
    componentMap: componentMap,
    key: `${data.sys.id}_${i}`,
    index: i,
    items: items
  }))));
};